import { TableRow, TableCell, ListItemText, Typography, IconButton, Grid, TableBody, TableHead, MenuItem, Menu, TableContainer, Link, ListItem, Icon, Button, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress } from "@material-ui/core";
import { Cancel, CancelOutlined, Edit, GetApp, MoreHoriz, RemoveCircleOutline, Replay, Timer, CheckCircleOutline, ErrorOutline, Cached, People, Settings, PlayArrow, ToggleOn, ToggleOff } from "@material-ui/icons";
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import React, { useEffect, useState, useRef } from "react";
import { Collapse, Table, Tooltip } from "react-bootstrap";
import clsx from 'clsx';
import { CancelBatch, CancelBatchConsole, getBatchOrders, DownloadAllResults, materialRevisionItemsExists, GetBatchParameters, createBatchParameters, getPdmCadCompareV2Status } from "./RestService";
import { useMsal } from "@azure/msal-react";
import CustomStatusIcon from "./CustomStatusIcon";
import { GridWindow } from "@material-ui/data-grid";
import { snackbar } from "../snackbarService";
import { ConvertedTimeString, GetEmpty, LoadParameters } from "./Common";
import config from "../config";
import ModalPopup from './ModalPopup';
import LinearProgress from '@material-ui/core/LinearProgress';


export default function BatchRow(props) {
    const [currentSelection, setCurrentSelection] = useState(props.currentSelection);
    const [orders, setOrders] = useState(null);
    const [orderElements, setCurrentOrderElements] = useState(null);
    const [selected, setSelected] = useState(false);
    const [lock, setLock] = useState(false);
    const [mainKey, setMainKey] = useState(1);
    const { instance, accounts } = useMsal();
    const classes = props.classes;
    const globalClasses = props.globalClasses;
    const index3 = props.index;
    const [b, setB] = useState(props.batch == null ? null : props.batch);
    const d = props.material;
    const shareObj = props.shareObj;
    const [errorPopupOpen, setErrorPopupOpen] = useState(false); 
    const [popupMessage, setPopupMessage] = useState('');
    const [circularProgressOpen, setCircularProgressOpen] = useState(false);
    const [progress, setProgress] = useState(0);
    
    const GetRunningNum = (orderName) => {
        let splitName = orderName.split("-");
        if (splitName.length >= 2) {   
            return splitName[splitName.length - 2].slice(-4);
        }
        else {
            return orderName.slice(-4);
        }
    };

    const handleDownloadClick = async (event, clickedOrder, clickedBatch) => {
        
        const downloadAction = () => {
            props.setAnchorElDownload(event.currentTarget);
            props.setClickedOrder(clickedOrder);
            props.setSelectedBatch(clickedBatch);
        } 
        props.checkPDMLoginAndRun(downloadAction);
    };

    const getActuallyExecutedOrders = (batch) => {
        if (!batch || !Array.isArray(batch.orders)) {
            return [];
        }

        return batch.orders.filter(order => {
            const status = String(order?.status || "")
                .trim()
                .toLowerCase();

            return status !== "" && status !== "not run";
        });
    };

    const getActuallyExecutedOrderCount = (batch) => {
        return getActuallyExecutedOrders(batch).length;
    };

    const getSuccessRate = (batch) => {
        const executedOrders = getActuallyExecutedOrders(batch);

        if (executedOrders.length === 0) {
            return "0.00%";
        }

        const successOrders = executedOrders.filter(order => {
            const status = String(order?.status || "")
                .trim()
                .toLowerCase();

            return (
                status === "job completed" ||
                status === "completed" ||
                status === "success"
            );
        }).length;

        return (
            (successOrders / executedOrders.length) *
            100
        ).toFixed(2) + "%";
    };

    const generateOrderElements = (clickedBatch) => {
        let tempOrders = [];
        let orderElements = [];
        
        if (clickedBatch["orders"].length > 0) {
            for (let oIndex = 0; oIndex < clickedBatch["orders"].length; oIndex++) {
                tempOrders.push(clickedBatch["orders"][oIndex]);
            }
        }
        tempOrders.sort((a,b) => parseInt(GetRunningNum(a["name"]), 10) - parseInt(GetRunningNum(b["name"]), 10));
        setOrders(tempOrders);

        const rawValue = clickedBatch?.executeArguments?.cws_error_recording; // string
        const errorstatusIsset = rawValue === "true"; // boolean
        
        if(tempOrders.length) {
            for (let index = 0; index < tempOrders.length; index++) {
                const element = tempOrders[index];
                    //console.log("ELEMENT: ", element);
                    let desc = "";
                    let caD_duration = "";
                    let caD_loops = "";
                    
                    if (element["description"])
                    {
                        desc = element["description"];
                    }
                    if (element["caD_duration"] != "not available")
                    {
                        caD_duration = element["caD_duration"];
                    }
                    if (element["caD_loops"] != "not available")
                    {
                        caD_loops = element["caD_loops"];
                    }
                    
                    let statusIcon = (<CustomStatusIcon status={"Not run"}></CustomStatusIcon>)
                    if (element["status"])
                    {
                    if (element.status?.toLowerCase() === "processing")
                        statusIcon = (<CustomStatusIcon status={"Processing"}></CustomStatusIcon>)
                    else if (element.status?.toLowerCase() === "failed" || element.status?.toLowerCase() === "pdm import error")
                        statusIcon = (<CustomStatusIcon status={"Failed"}></CustomStatusIcon>)
                    else if (element.status?.toLowerCase() === "cancelled")
                        statusIcon = (<CustomStatusIcon status={"Cancelled"}></CustomStatusIcon>)
                    else if (["job completed", "completed"].includes(element.status?.toLowerCase()))
                        statusIcon = (<CustomStatusIcon status={"Success"}></CustomStatusIcon>) 
                    }

                    const statusMap = {
                        "Processing": "Processing",
                        "FAILED": "Failed",
                        "JOB COMPLETED": "Success",
                    };

                    const statusLookup = !errorstatusIsset
                        ? "Not run"
                        : element?.status?.toLowerCase() === "pdm import error"
                            ? "FAILED"
                            : statusMap[element?.status] || "Not run";
 

                    const errorstatusIcon = <Tooltip title={statusLookup}><CustomStatusIcon status={statusLookup}  /></Tooltip>;
                    
                    let pdmUrl = config.pdmUrl+"#!object?obj_id=test_case:";
                    let pdmConfUrl = config.pdmUrl+"#!object?obj_id=item:";
                    
                    orderElements.push(
                        <TableRow key={"orders_data_" + (index) + "_" + element["name"] + mainKey} className={classes.orderRow} style={{background:"white"}}>
                            
                            <TableCell className={classes.newbatchCell} align="center" colSpan={2}>
                                <Table className={classes.tableres} style={{display:"block"}}>
                                    <TableRow style={{width:"100%", display:"flex"}}>
                                        <TableCell className={classes.newbatchCell} style={{textAlign: "center", width: "10%", fontSize: "smaller", borderBottom: "0px solid", marginLeft: "13%", margin: "auto"}} align="right">
                                        </TableCell>
                                        <TableCell className={classes.newbatchCell} align="left" style={{fontSize: "smaller", width: "70%", borderBottom: "0px solid", paddingTop: "1%", paddingBottom: "1%"}}>
                                        <ListItem style={{ textAlign: "left"}}>
                                            <ListItemText
                                                style={{ overflow: "ellipsis"}}
                                                disableTypography
                                                primary={
                                                element["status"] != "Not run" && element["status"] != "Processing" ?
                                                <Typography style={{ margin: "0",textOverflow: "clip", wordBreak: "break-word", whiteSpace: "normal", width: "100%"}} className={globalClasses.smallFont}><Link target="_blank" href={pdmUrl + element["name"]}>{element["name"]}</Link></Typography>
                                                :
                                                <Typography style={{ margin: "0",textOverflow: "clip", wordBreak: "break-word", whiteSpace: "normal", width: "100%"}} className={globalClasses.smallFont}>{element["name"]}</Typography>
                                            }
                                                secondary={<Tooltip title={desc}><Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)", whiteSpace: "pre-line"}}>{desc.length > 46 ? desc.slice(0, 43) + "..." : desc}</Typography> </Tooltip>
                                                } 
                                            />
                                        
                                        </ListItem>
                                        </TableCell>
                                        <TableCell className={classes.newbatchCell} style={{textAlign: "center", fontSize: "smaller", width:"20%", borderBottom: "0px solid", marginLeft: "13%", margin: "auto"}} align="center">
                                        {
                                            element["configurationId"] != null   
                                            ?  
                                            element["configurationId"] != ""
                                            ?
                                            element["configurationId"] != "not available"
                                            ?
                                            <Tooltip title={"Link to configuration"}>
                                            <IconButton className={globalClasses.customButton} aria-controls="simple-menu" aria-haspopup="true" onClick={(e) => window.open(pdmConfUrl + element["configurationId"], '_blank')}>
                                                <Settings />
                                            </IconButton>
                                            </Tooltip>
                                            :
                                            <></>
                                            :
                                            <></>
                                            : 
                                            <></>
                                        }
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="center" onClick={element.status?.toLowerCase() === "failed" ? () => handleOpenErrorPopup(b,element) : null} style={{ cursor: element.status?.toLowerCase() === "failed" ? 'pointer' : 'default' }}>
                                <Tooltip title={element["status"]}>
                                    {statusIcon}
                                    {/* <RemoveCircleOutline className={classes.NotRunIcon} /> */}
                                </Tooltip>
                            </TableCell>

                            <TableCell className={classes.newbatchCell} align="center">

                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="center">
                                {
                                    (() => {
                                        const orderStatus = String(element?.status || "").toLowerCase();

                                        const canShowOrderDownload =
                                            GetEmpty(element["configurationId"]) == false &&
                                            element["configurationId"] != "" &&
                                            element["configurationId"] != "not available" &&
                                            orderStatus !== "cancelled" &&
                                            orderStatus !== "cancel";

                                        return canShowOrderDownload ? (
                                            <IconButton
                                                disabled={getExpectedDownloadTypes(clickedBatch).length === 0}
                                                className={globalClasses.customButton}
                                                aria-controls="simple-menu"
                                                align="left"
                                                aria-haspopup="true"
                                                onClick={(e) => {
                                                    if (getExpectedDownloadTypes(clickedBatch).length === 0) {
                                                        return;
                                                    }

                                                    handleDownloadClick(e, element, clickedBatch);
                                                }}
                                            >
                                                <GetApp />
                                            </IconButton>
                                        ) : (
                                            <IconButton
                                                disabled={true}
                                                className={globalClasses.customButton}
                                                aria-controls="simple-menu"
                                                align="left"
                                                aria-haspopup="true"
                                            >
                                                <GetApp />
                                            </IconButton>
                                        );
                                    })()
                                }
                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="center" onClick={statusLookup != "Not run" && element.status?.toLowerCase() === "failed" ? () => handleOpenErrorPopup(b,element) : null} style={{ cursor: element.status?.toLowerCase() === "failed" ? 'pointer' : 'default' }}>
                                {errorstatusIcon} 
                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="right" colSpan={1} style={{paddingRight: "50px", fontSize: "smaller", fontWeight: "bold", paddingTop: "1%", paddingBottom: "1%"}}>
                            
                            </TableCell>
                            <TableCell className={classes.newbatchCell} align="center" colSpan={6}>
                                <TableRow  style={{width:"100%", display:"flex"}}>
                                    <TableCell className={classes.orderCell} align="center" style={{fontSize: "smaller", width: "50%"}}>
                                        <Tooltip title={"Cad Duration"} placement="bottom-start">
                                        <Grid container direction="row" alignItems="center" spacing={1} justifyContent="center">
                                            <Timer fontSize='small' />
                                            <Typography style={{paddingLeft: "4px"}}> {caD_duration}</Typography>
                                        </Grid>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell className={classes.orderCell} style={{paddingRight: "8px", fontSize: "smaller", width:"50%", paddingTop: "2%"}} align="right">
                                        <Tooltip title={"Cad Loops"} placement="bottom-start">
                                        <Grid container direction="row" alignItems="center" spacing={1} justifyContent="center">
                                            <Replay fontSize='small' />
                                            <Typography style={{paddingLeft: "4px"}}> {caD_loops}</Typography>
                                        </Grid>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            </TableCell>
                        </TableRow>
                        );    
            }
        } else {
            orderElements.push(
                <TableRow className={classes.orderRow} style={{background:"white", height:"50px"}}>
                    <TableCell className={classes.newbatchCell} align="center" colSpan={13}>
                        No test orders found.
                    </TableCell> 
                </TableRow>
            );
        } 
        
        setCurrentOrderElements(orderElements);
    };

    const handleBatchClick = async (index, clickedBatch) => {
        console.log("clickedBatch: ", clickedBatch);
        await LoadParameters(instance, clickedBatch);
        setSelected(!selected);
        if (orderElements == null)
        {
            generateOrderElements(clickedBatch);
        }
        props.handleBatchClick(index, clickedBatch);
    }

    const handleEditClick = (e, clickedBatch, kmID, kmRev, clickedOrders) => {
        //console.log(clickedBatch);
        console.log("clickedBatch: ", clickedBatch);
        console.log("kmID: ", kmID);
        console.log("kmRev: ", kmRev);
        console.log("clickedOrders: ", clickedOrders);
        props.handleEditClick(e, clickedBatch, kmID, kmRev, clickedOrders)
    };

    const handleErrorClick = (b, element) => {
        const errors = GetOrderErrorModeErrors(b, element)[0];
        console.log("errorsStr: ", errors);
        props.handleSetErrorModeDialog(errors);
    }
    
    const handleOpenErrorPopup = (b, element) => {
        setPopupMessage(element["popupMsgStatus"]);
        setErrorPopupOpen(true);
    };

     const handleCloseErrorPopup = () => {
        setErrorPopupOpen(false);
    };

    const getExpectedDownloadTypes = (batch) => {
        const args = batch?.executeArguments || {};

        const sendToCAD = args.sendToCAD === true || args.sendToCAD === "true";
        const deepCheck = args.levelOfScan === "deep_check";
        const saveTrace = args.saveTrace === true || args.saveTrace === "true";
        const downloadMFG = args.downloadMFG === true || args.downloadMFG === "true";

        let resultTypes = [];

        if (sendToCAD) {
            resultTypes.push("XML");
            resultTypes.push("LOG");
            resultTypes.push("PDM");
        }

        if (sendToCAD && deepCheck) {
            resultTypes.push("MCLOG");
        }

        if (sendToCAD && downloadMFG) {
            resultTypes.push("MFG");
        }

        if (saveTrace) {
            resultTypes.push("TRACE");
        }

        // console.log("Filtered resultTypes:", resultTypes);

        return resultTypes;
    };

    const hasAnyAvailableDownloadItem = (batch) => {
        if (!batch || !Array.isArray(batch.orders))
            return false;

        const expectedTypes = getExpectedDownloadTypes(batch);

        if (expectedTypes.length === 0)
            return false;

        return batch.orders.some(order => {
            if (
                !order.configurationId ||
                order.configurationId === "not available"
            ) {
                return false;
            }

            return expectedTypes.some(type => {
                return props.downloadAvailability?.[`${order.configurationId}_${type}`] === true;
            });
        });
    };

    const hasValidDownloadableExecutedOrder = (batch) => {
        if (!batch || !Array.isArray(batch.orders))
            return false;

        return batch.orders.some(order => {
            const orderStatus = String(order.status || "").toLowerCase();

            return (
                (
                    orderStatus === "job completed" ||
                    orderStatus === "completed" ||
                    orderStatus === "success" ||
                    orderStatus === "failed" ||
                    orderStatus === "pdm import error"
                ) &&
                order.configurationId &&
                order.configurationId !== "" &&
                order.configurationId !== "not available"
            );
        });
    };

    const shouldDisableDownloadAll = (batch) => {
        if (!batch) {
            return true;
        }

        const status = String(batch.status || "").toLowerCase();

        if (status === "processing" || status === "inprogress") {
            return true;
        }

        const resultTypes = getExpectedDownloadTypes(batch);

        if (resultTypes.length === 0) {
            return true;
        }

        const allowedBatchStatus =
            status === "success" ||
            status === "partialfailed" ||
            status === "failed" ||
            status === "not run" ||
            status === "cancelled" ||
            status === "cancel" ||
            status === "pdm import error";

        if (!allowedBatchStatus) {
            return true;
        }

        if (Array.isArray(batch.orders) && batch.orders.length > 0) {
            return !hasValidDownloadableExecutedOrder(batch);
        }

        return false;
    };

    const getDownloadAllTooltip = (batch) => {
        const status = String(batch?.status || "").toLowerCase();

        if (status === "processing" || status === "inprogress") {
            return "Download All will be available after the batch completes. Individual order files can be downloaded if they are already available.";
        }

        if (shouldDisableDownloadAll(batch)) {
            return "No downloadable result files are available for this batch.";
        }

        return "Download results for the entire batch";
    };



    const hasProcessingOrders = (batch) => {
        if (!batch || !Array.isArray(batch.orders))
            return false;

        return batch.orders.some(order => {
            const orderStatus = String(order.status || "").toLowerCase();

            return (
                orderStatus === "processing" ||
                orderStatus === "inprogress"
            );
        });
    };

    const isBatchStillRunningForDownload = (batch) => {
        if (!batch)
            return false;

        const batchStatus = String(batch.status || "").toLowerCase();

        if (
            batchStatus === "processing" ||
            batchStatus === "inprogress"
        ) {
            return true;
        }

        if (!Array.isArray(batch.orders))
            return false;

        return batch.orders.some(order => {
            const orderStatus = String(order.status || "").toLowerCase();

            return (
                orderStatus === "processing" ||
                orderStatus === "inprogress"
            );
        });
    };

    const handleBatchDownloadClick = async (b, event) => {
        event?.currentTarget?.blur(); 
        await LoadParameters(instance, b);
        const downloadAction = async () => {
            let tempBatch = b;
            let tmpOrders = [];
            let tmpOrderNames = [];

            if (!GetEmpty(tempBatch["orders"])) {
                tempBatch["orders"].forEach(element => {
                    const orderStatus = String(element["status"] || "").toLowerCase();

                    if (
                        (
                            orderStatus === "job completed" ||
                            orderStatus === "completed" ||
                            orderStatus === "success" ||
                            orderStatus === "failed" ||
                            orderStatus === "cancelled" ||
                            orderStatus === "pdm import error"
                        ) &&
                        element["configurationId"] &&
                        element["configurationId"] !== "not available"
                    ) {
                        tmpOrders.push(element["configurationId"]);
                        tmpOrderNames.push(element["name"]);
                    }
                });
            }

            if (tmpOrders.length === 0) {
                alert("There are no test orders results found for this batch");
                return;
            }

            let batchName = tempBatch["name"];
            let batchOrderListsName = tmpOrders.map(String).join(",");

            sessionStorage.setItem("circularProgress", "true");
            sessionStorage.setItem("downloadProgress", "0");
            setProgress(0);
            setCircularProgressOpen(true);
            let compareMap = {};

            const args = tempBatch["executeArguments"] || {};
            const isPdmCadCompareEligible =
                args["levelOfScan"] === "deep_check" &&
                args["sendToCAD"] === "true" &&
                args["confPDM"] === "true" &&
                args["relationships"] !== "\"cws_configure_no_relationships\"";

            if (isPdmCadCompareEligible) {
                for (const configurationId of tmpOrders) {
                    try {
                        const status = await getPdmCadCompareV2Status(instance, configurationId);

                        if (status && status.exists === true && status.compareName) {
                            compareMap[configurationId] = status.compareName;
                        }
                    }
                    catch (error) {
                        console.log("PDM CAD Comparison status check failed for Download All:", configurationId, error);
                    }
                }
            }

            const compareMapJson = JSON.stringify(compareMap);

            DownloadAllResults(
                instance,
                batchName,
                batchOrderListsName,
                tmpOrderNames.join(','),
                "DWN",
                accounts[0].username,
                compareMapJson,
                "final"
            );
        };

        props.checkPDMLoginAndRun(downloadAction);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            const val = sessionStorage.getItem("downloadProgress");
            if (val !== null) {
                setProgress(Number(val));
            }
        }, 300);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            let circularProgress = sessionStorage.getItem("circularProgress");
			if(circularProgress=="false")
			{
				setCircularProgressOpen(false);
                if(document.getElementById("CirProg"))
                {
                    document.getElementById("CirProg").style.display="none";
                }
			}
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const CancelButton = async (clickedBatch) => {
        setLock(true);
        console.log("clickedBatch: ", clickedBatch);
        await LoadParameters(instance, clickedBatch);
        let message = "";
        let answer = window.confirm("Are you sure you want to cancel the run?");
        if (answer == true)
        {
            let regex = new RegExp("(?:" + clickedBatch["executeOrders"].join("|") + ")$");
            clickedBatch["orders"].forEach(order => {
                if (order["name"].match(regex)) {
                    order["status"] = "Cancelled";
                order["configurationid"] = "not available";
                order["cad_duration"] = "not available";
                order["cad_loops"] = "not available";
                order["mc_color"] = "not available";
                order["popupmsgstatus"] = "not available";
                }
            });
            RefreshOrders();
            const cancelBatchResult = await CancelBatch(instance, clickedBatch["id"], clickedBatch["orders"]);
            if (cancelBatchResult["exception"])
            {
                snackbar.warning(cancelBatchResult["exception"],300000);
                setLock(false);
            }            
            else
            {
                const parameterData = await createBatchParameters(instance, clickedBatch["id"], clickedBatch["orders"], clickedBatch["defaultCharacteristics"]);
                    if(parameterData && parameterData.exception) {
                        setLock(false);
                        snackbar.warning("Failed to update order cancel information to S3.",300000);
                    }
                    else
                    {
                        snackbar.success("Batch execute stopped.",300000);
              clickedBatch["status"] = "Cancelled";
              props.handleCancelClick(clickedBatch);
              props.setReRender(!props.reRender);
            }

            }
            const cancelBatchConsoleResult = await CancelBatchConsole(instance, accounts[0].username, clickedBatch["name"],clickedBatch["lastRun"]);
            setLock(false);
            if (cancelBatchConsoleResult == "Failed") {
                snackbar.warning("Console side failed to cancel batch.",300000);
            }  
        }
    };

    const RefreshOrders = () => {
        generateOrderElements(b);
    }

    useEffect(() => {
        setB(props.batch);
        setMainKey(mainKey + 1);
        RefreshOrders();
    }, [props.batch, props.reRender]);

    useEffect(() => {
        //RefreshOrders();
    }, [b]);

    useEffect(() => {
        if (props.batch) {
            setB(props.batch);
            
            if (selected && props.batch["orders"]) {
                generateOrderElements(props.batch);
            }
        }
    }, [props.batch, selected]);

    const GetErrorMode = (tmpBatch) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        //let modeIcon = <RemoveCircleOutline className={globalClasses.NotRunIcon} />
        let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        if (tmpBatch) {   
            if (tmpBatch["executeArguments"])
            {
                if (tmpBatch["executeArguments"]["cws_error_recording"])
                {
                    if (tmpBatch["executeArguments"]["cws_error_recording"] == "true")
                    {
                        //modeIcon = <ToggleOn className={globalClasses.successIcon} />
                        //modeIcon = <CheckCircleOutline className={globalClasses.successIcon} />
                        modeIcon = <Icon style={{backgroundColor: "#4BB543", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>On</Icon>
                    }   
                    else
                    {
                        //modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
                        //modeIcon = <RemoveCircleOutline className={globalClasses.NotRunIcon} />
                        modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
                    }
                }
            }
        }
        return modeIcon;
    };

    const GetErrorModeStatus = (tmpBatch) => {
        let modeStatus = "Off";
        if (tmpBatch) {   
            if (tmpBatch["executeArguments"])
            {
                if (tmpBatch["executeArguments"]["cws_error_recording"])
                {
                    if (tmpBatch["executeArguments"]["cws_error_recording"] == "true")
                    {
                        modeStatus = "On";
                    }   
                    else
                    {
                        modeStatus = "Off";
                    }
                }
            }
        }
        return modeStatus;
    };

    const GetSkipMode = (tmpBatch) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        if (tmpBatch) {   
            if (tmpBatch["executeArguments"])
            {
                if (tmpBatch["executeArguments"]["cws_testing_skip_objects"])
                {
                    if (tmpBatch["executeArguments"]["cws_testing_skip_objects"] != "")
                    {
                        //modeIcon = <ToggleOn className={globalClasses.successIcon} />
                        modeIcon = <Icon style={{backgroundColor: "#4BB543", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>On</Icon>
                    }   
                    else
                    {
                        //modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
                        modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
                    }
                }
            }
        }
        return modeIcon;
    };

    const GetSkipModeStatus = (tmpBatch) => {
        let modeStatus = "Off";
        if (tmpBatch) {   
            if (tmpBatch["executeArguments"])
            {
                if (tmpBatch["executeArguments"]["cws_testing_skip_objects"])
                {
                    if (tmpBatch["executeArguments"]["cws_testing_skip_objects"] != "")
                    {
                        modeStatus = "On";
                    }   
                    else
                    {
                        modeStatus = "Off";
                    }
                }
            }
        }
        return modeStatus;
    };

    const GetOrderErrorMode = (tmpBatch, currentOrder) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        let modeIcon = <RemoveCircleOutline className={globalClasses.NotRunIcon} />
        //let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        // console.log("BATCH: ", tmpBatch);
        // console.log("currentOrder: ", currentOrder);
        
        let checkErrorModes = true;
        if (tmpBatch["errorModeStatus"])
        {
            if (tmpBatch["errorModeStatus"].toLowerCase() == "processing")
            {
                checkErrorModes = false;
                let foundExecOrder = false;
                if (tmpBatch["executeOrders"])
                {
                    if (tmpBatch["executeOrders"].length > 0)
                    {
                        tmpBatch["executeOrders"].forEach(element => {
                            if (currentOrder["name"].endsWith(element))
                            {
                                modeIcon = <Cached className={globalClasses.inProgressIcon} />
                                foundExecOrder = true;
                            }
                        });
                    }   
                }
            }
        }
        else
        {
            checkErrorModes = false;
        }
        if (props.batchesErrorModes != null && checkErrorModes == true)
        {
            // console.log("props.batchesErrorModes: ", props.batchesErrorModes);
            if (props.batchesErrorModes.length > 0)
            {
                let findBatch = props.batchesErrorModes.find(x => x.batchID == tmpBatch["id"]);
                if (findBatch)
                {
                    let findOrder = findBatch["errorModeOrders"].find(tmpOrder => tmpOrder.name == currentOrder.name);
                    if (findOrder)
                    {
                        modeIcon = <ErrorIcon className={globalClasses.errorIcon} />
                    }
                    else
                    {
                        let foundExecOrder = false;
                        if (tmpBatch["executeOrders"])
                        {
                            if (tmpBatch["executeOrders"].length > 0)
                            {
                                tmpBatch["executeOrders"].forEach(element => {
                                    if (currentOrder["name"].endsWith(element))
                                    {
                                        modeIcon = <SuccessIcon className={globalClasses.successIcon} />
                                    }
                                });
                            }   
                        }
                        
                    }
                }
            }
        }
        return modeIcon;
    };

    const GetOrderErrorModeStatus = (tmpBatch, currentOrder) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        let modeStatus = "Unavailable";
        //let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        // console.log("BATCH: ", tmpBatch);
        // console.log("currentOrder: ", currentOrder);
        
        let checkErrorModes = true;
        if (tmpBatch["errorModeStatus"])
        {
            if (tmpBatch["errorModeStatus"].toLowerCase() == "processing")
            {
                checkErrorModes = false;
                let foundExecOrder = false;
                if (tmpBatch["executeOrders"])
                {
                    if (tmpBatch["executeOrders"].length > 0)
                    {
                        tmpBatch["executeOrders"].forEach(element => {
                            if (currentOrder["name"].endsWith(element))
                            {
                                modeStatus = "Processing"
                                foundExecOrder = true;
                            }
                        });
                    }   
                }
            }
        }
        else
        {
            checkErrorModes = false;
        }
        if (props.batchesErrorModes != null && checkErrorModes == true)
        {
            // console.log("props.batchesErrorModes: ", props.batchesErrorModes);
            if (props.batchesErrorModes.length > 0)
            {
                let findBatch = props.batchesErrorModes.find(x => x.batchID == tmpBatch["id"]);
                if (findBatch)
                {
                    let findOrder = findBatch["errorModeOrders"].find(tmpOrder => tmpOrder.name == currentOrder.name);
                    if (findOrder)
                    {
                        modeStatus = "Errors";
                    }
                    else
                    {
                        let foundExecOrder = false;
                        if (tmpBatch["executeOrders"])
                        {
                            if (tmpBatch["executeOrders"].length > 0)
                            {
                                tmpBatch["executeOrders"].forEach(element => {
                                    if (currentOrder["name"].endsWith(element))
                                    {
                                        modeStatus = "Success";
                                    }
                                });
                            }   
                        }
                        
                    }
                }
            }
        }
        return modeStatus;
    };

    const GetOrderErrorModeErrors = (tmpBatch, currentOrder) => {
        //let modeIcon = <ToggleOff className={globalClasses.NotRunIcon} />
        let errors = [];
        //let modeIcon = <Icon style={{backgroundColor: "gray", borderRadius: "8px", paddingLeft: "8px", paddingRight: "8px", fontSize: "medium", color: "#fff"}}>Off</Icon>
        
        let checkErrorModes = true;
        if (tmpBatch["errorModeStatus"])
        {
            if (tmpBatch["errorModeStatus"].toLowerCase() == "processing")
            {
                checkErrorModes = false;
            }
        }
        else
        {
            checkErrorModes = false;
        }
        if (props.batchesErrorModes != null && checkErrorModes == true)
        {
            //console.log("props.batchesErrorModes: ", props.batchesErrorModes);
            if (props.batchesErrorModes.length > 0)
            {
                let findBatch = props.batchesErrorModes.find(x => x.batchID == tmpBatch["id"]);
                if (findBatch)
                {
                    let findOrder = findBatch["errorModeOrders"].find(tmpOrder => tmpOrder.name == currentOrder.name);
                    if (findOrder)
                    {
                        errors.push(findOrder["errors"]);
                    }
                }
            }
        }
        return errors;
    };

    const hasSelectedOrders = Array.isArray(b?.executeOrders) && b.executeOrders.some(order => {
        return order && order !== "All";
    });

    return (
        <React.Fragment key={b["key"] + "_main" + mainKey}>
        <TableRow key={b["key"]} className={clsx({
            [classes.activeBatch]: selected,
            [classes.batchDataRow]: true
        })}>
            <TableCell className={classes.newbatchCell} align="right" onClick={() => handleBatchClick(index3, b)}>
                {
                    b["status"] != "Processing" &&
                    props.sharedToMe == false &&
                    hasSelectedOrders
                    ?
                    <Tooltip title="Execute batch">
                        <IconButton className={clsx(globalClasses.customButton, globalClasses.blueColor)} onClick={(e) => {
                            e.stopPropagation();
                            props.handleBatchExecuteOpenClick(e, b);
                        }}>
                            <PlayArrow />
                        </IconButton>
                    </Tooltip>
                    :
                    <></>
                }
                
            </TableCell>
            <TableCell className={classes.newbatchCell} style={{paddingLeft: "5px"}} align="left" onClick={() => handleBatchClick(index3, b)}>
                <ListItemText
                    style={{ margin: "0"}}
                    
                    disableTypography
                    primary={<Typography style={{ margin: "0",textOverflow: "clip", wordBreak: "break-word", whiteSpace: "normal", width: "100%"}} className={clsx({
                        [classes.activeBatchText]: selected,
                        [globalClasses.smallFont]: true
                    })}>{b["name"] + ", " + (b["description"] == null ? " " : b["description"])}</Typography>}
                    secondary={<Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)", whiteSpace: "pre-line"}}>{props.orderSecondaryText}</Typography> 
                }
                />
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center" onClick={() => handleBatchClick(index3, b)}>
                <Tooltip title={b["status"]}>
                    {props.statusIcon}
                </Tooltip>
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center">
                <Typography className={globalClasses.smallFont} onClick={() => handleBatchClick(index3, b)}>{b["material"] + "/" + b["materialRevision"]}</Typography>
                {
                    b["pdmDescription"] === undefined ? <></> : <Typography style={{ fontSize: "0.75rem", color: "rgba(0, 0, 0, 0.55)", whiteSpace: "pre-line"}} onClick={() => handleBatchClick(index3, b)}>{b["pdmDescription"]}</Typography>
                }
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center">
                <Tooltip title={getDownloadAllTooltip(b)}>
                    <span>
                        <IconButton
                            disabled={shouldDisableDownloadAll(b)}
                            className={globalClasses.customButton}
                            style={{ textAlign: "center" }}
                            onClick={(e) => {
                                if (shouldDisableDownloadAll(b)) {
                                    return;
                                }

                                handleBatchDownloadClick(b, e);
                            }}
                        >
                            <GetApp />
                        </IconButton>
                    </span>
                </Tooltip>
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center">
                <Tooltip title={GetErrorModeStatus(b)}>
                    {GetErrorMode(b)}
                </Tooltip>
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center" onClick={() => handleBatchClick(index3, b)}>
                <Tooltip title={GetSkipModeStatus(b)}>
                    {GetSkipMode(b)}
                </Tooltip>
            </TableCell>
            {/* Success rate */}
            <TableCell
                className={classes.newbatchCell}
                align="center"
                onClick={() => handleBatchClick(index3, b)}
            >
                <ListItemText
                    style={{ margin: "0" }}
                    disableTypography
                    primary={
                        <Typography className={globalClasses.smallFont}>
                            {getSuccessRate(b)}
                        </Typography>
                    }
                    secondary={
                        <Typography
                            style={{
                                fontSize: "0.75rem",
                                color: "rgba(0, 0, 0, 0.55)"
                            }}
                        >
                            {props.lastRun
                                ? ConvertedTimeString(props.lastRun)
                                : " "}
                        </Typography>
                    }
                />
            </TableCell>

            {/* Last run */}
            <TableCell
                className={classes.newbatchCell}
                align="center"
                onClick={() => handleBatchClick(index3, b)}
            >
                <Typography>
                    {getActuallyExecutedOrderCount(b)}
                </Typography>
            </TableCell>

            {/* Batch size */}
            <TableCell
                className={classes.newbatchCell}
                align="center"
                onClick={() => handleBatchClick(index3, b)}
            >
                <Typography className={globalClasses.smallFont}>
                    {b["batchSize"] !== undefined
                        ? b["batchSize"]
                        : b["orders"]
                            ? b["orders"].length
                            : 0}
                </Typography>
            </TableCell>
            <TableCell className={classes.newbatchCell} align="center" onClick={() => handleBatchClick(index3, b)}>
                {
                    b["sharedTo"] === undefined ? <></> : 
                    b["sharedTo"] == null ? <></> :
                    b["sharedTo"].length > 0 ?
                    <IconButton style={{marginRight: "8px"}} className={globalClasses.customButton} onClick={(e)=>{
                        props.handleBatchShareOpenClick(e, shareObj, b);
                        e.stopPropagation();
                        }}>
                        <People />
                    </IconButton> 
                    : null
                }
            </TableCell>
            <TableCell className={classes.newbatchCell} style={{paddingRight: "8px"}} align="right" onClick={() => handleBatchClick(index3, b)}>
                
                {
                    b["status"] == "Processing" && props.sharedToMe == false 
                    ?
                    <IconButton title={"Cancel"} style={{marginRight: "8px"}} className={globalClasses.customButton} onClick={(e)=>{
                        CancelButton(b);
                        e.stopPropagation();
                    }}>
                        <CancelOutlined />
                    </IconButton>
                    : 
                    <IconButton style={{width: "32px"}} className={globalClasses.customButton}>

                    </IconButton>
                }
                <IconButton className={globalClasses.customButton} aria-controls="batch-actions-menu" aria-haspopup="true" onClick={(e) => {
                    e.stopPropagation();
                    const menuAnchor = e.currentTarget;

                    props.checkPDMLoginAndRun(() => {
                        props.handleSetAnchorElBatch(menuAnchor, b, d["id"], d["revision"], orders, shareObj);
                    });
                }}>
                    <MoreHoriz />
                </IconButton>
            </TableCell>
        </TableRow>
        
        
        <Collapse  unmountOnExit in={selected}>
            <TableContainer style={{ minHeight: "80px", maxHeight: "300px", overflow: "auto", display: "contents"}}>
                <TableRow key={"order_table_" + b["key"]} style={{background:"seashell"}}>
                    <TableCell className={classes.newbatchCell} align="center" colSpan={2}>
                        <Table className={classes.tableres} style={{width:"stretch"}}>
                            <TableRow>
                                <TableCell className={classes.newbatchCell} align="center" style={{fontSize: "smaller", fontWeight: "bold", width: "10%",borderBottom: "0px solid"}}>
                                </TableCell>
                                <TableCell className={classes.newbatchCell} align="left" style={{fontSize: "smaller", fontWeight: "bold", width: "70%",borderBottom: "0px solid", paddingLeft:"15px"}}>
                                {"Test Order"}
                                </TableCell>
                                <TableCell className={classes.newbatchCell} style={{fontSize: "smaller", fontWeight: "bold", borderBottom: "0px solid", width: "20%", paddingRight: "5px"}} align="center">
                                {"Configuration"} 
                                </TableCell>
                            </TableRow>
                        </Table>
                    </TableCell>
                    <TableCell className={classes.newbatchCell} align="center" style={{fontSize: "smaller", fontWeight: "bold", paddingTop: "1%", paddingBottom: "1%"}}>
                        {"Order Status"}
                    </TableCell>
                    <TableCell className={classes.newbatchCell} align="right" colSpan={3} style={{fontSize: "smaller", fontWeight: "bold", paddingTop: "1%", paddingBottom: "1%"}}>
                        {"Error Mode Message"}
                    </TableCell>
                    <TableCell className={classes.newbatchCell} align="right" colSpan={1} style={{paddingRight: "50px", fontSize: "smaller", fontWeight: "bold", paddingTop: "1%", paddingBottom: "1%"}}>
                        {""}
                    </TableCell>
                    <TableCell className={classes.newbatchCell} align="center" colSpan={6}>
                        <TableRow style={{width:"100%", display:"flex"}}>
                            <TableCell className={classes.newbatchCell} align="center" style={{fontSize: "smaller", fontWeight: "bold", width: "50%", borderBottom: "0px solid", paddingTop: "1%", paddingBottom: "1%"}}>
                            {"CAD configuration time"}
                            </TableCell>
                            <TableCell className={classes.newbatchCell} style={{paddingRight: "8px", fontSize: "smaller", fontWeight: "bold", width:"50%", borderBottom: "0px solid", paddingTop: "1%", paddingBottom: "1%"}} align="center">
                            {"CAD re-generation loops"}   
                            </TableCell>
                        </TableRow>
                    </TableCell>
                </TableRow>
                {orderElements == null ? <></> : orderElements}
            </TableContainer>
        </Collapse>
        
        {/* Error Dialog */}
        <Dialog open={errorPopupOpen} onClose={handleCloseErrorPopup} aria-labelledby="error-popup-title">
            <DialogTitle id="error-popup-title">Error</DialogTitle>
            <DialogContent>
            <p>{popupMessage}</p>
                <p>There was an error processing this batch. Please try again.</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseErrorPopup} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
        <Dialog open={circularProgressOpen} id="CirProg">
        <DialogTitle>
            {progress <= 0
                ? "Preparing file..."
                : progress >= 100
                    ? "Finalizing download..."
                    : `Downloading file (${progress}%)`}
        </DialogTitle>

        <div style={{ padding: "20px", width: "300px" }}>
            <LinearProgress
                variant={progress <= 0 || progress >= 100 ? "indeterminate" : "determinate"}
                value={progress}
                style={{ height: "10px", borderRadius: "5px" }}
            />

            <div style={{ textAlign: "center", marginTop: "10px" }}>
                {progress <= 0
                    ? "Please wait..."
                    : progress >= 100
                        ? "Almost done..."
                        : `${progress}%`}
            </div>
        </div>
    </Dialog>
        </React.Fragment>
    );
}